import { DefaultButton, IconButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { DetailsList, SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import React, { Component } from 'react';
import Scriba from 'react-scriba';
import { DataReglement } from '../../data/DataReglement';
import { DataSuiviCompteClient } from '../../data/DataSuiviCompteClient';
import { MaxLengths } from '../../data/MaxLenghts';
import { Immocom } from '../../specifique/immocom';
import { EUIComboBox } from '../EUI/EUIComboBox';
import { EUIDatePicker } from '../EUI/EUIDatePicker';
import { EUITextField } from '../EUI/EUITextField';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';
import './FicheSuiviCompteClient.css';

var objetState = {
    reglement: {},
    listReglements: [],
    totalFacture: 0,
    totalEncaisse: 0,
    totalAEncaisser: 0,

    enCoursDeTraitement: false,
    messageEnCoursTraitement: '',

    onActiveBoutonEnregistrer: false,

    hideMessageBarError: true,
    errorMessage: '',
    hideMessageBarWarning: true,
    warningMessage: '',
};

export class FicheSuiviCompteClient extends Component {

    static defaultProps = {
        acquereur: {}, // permet de récupérer le nom de l'acquéreur
        idOperation: undefined,
        idReservation: undefined,
        peutModifierBlocSuiviCompteClient: false,
        peutSupprimerBlocSuiviCompteClient: false,
    };

    _creationContent = () => {

        return <div className="ms-Grid" dir="ltr">
            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <div className="ms-Grid-row">
                <MessageBars
                    errorMessage={this.state.errorMessage}
                    warningMessage={this.state.warningMessage}
                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                />
            </div>

            <div className="ms-Grid-row blocTotauxSuiviCompteClient">
                <div className="ms-Grid-col ms-sm12 ms-xl6" />
                <div className="ms-Grid-col ms-sm12 ms-xl6">
                    <div className="ms-Grid-col ms-sm12 ms-lg4">
                        <div className="divTotalSuiviCompteClient">
                            <span className="labelMontantSuiviCompteClient">Total facturé : </span>
                            <span className="montantSuiviCompteClient">{Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee((this.state.totalFacture).toFixed(2), false, 2)}&nbsp;€</span>
                        </div>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg4">
                        <div className="divTotalSuiviCompteClient">
                            <span className="labelMontantSuiviCompteClient">Total encaissé : </span>
                            <span className="montantSuiviCompteClient">{Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee((this.state.totalEncaisse).toFixed(2), false, 2)}&nbsp;€</span>
                        </div>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg4">
                        <div className="divTotalSuiviCompteClient">
                            <span className="labelMontantSuiviCompteClient">Total à encaisser : </span>
                            <span className="montantSuiviCompteClient">{Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee((this.state.totalAEncaisser).toFixed(2), false, 2)}&nbsp;€</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12 ms-xl6 blocSuiviCompteClient">
                    <div className="ms-Grid-row">
                        <div className="titreBlocSuiviCompteClient">Encaissement</div>
                    </div>
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-lg6">
                            <EUITextField
                                disabled
                                label="Nom client"
                                value={!!this.props.acquereur && this.props.acquereur.nom}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg6">
                            <EUITextField
                                disabled
                                label="Affectation"
                            />
                        </div>
                    </div>
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-lg6">
                            <EUIDatePicker
                                label="Date"
                                onSelectDate={date => this._onMiseAJourChamp("reglement", "dateMouvement", Scriba.date().getChaineISOFromDate(date), this._onVerificationFormulaire)}
                                value={this.state.reglement.dateMouvement}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg6">
                            <TextField // Note KP : TextFieldNombre en cours de test
                                label="Montant"
                                value={Scriba.officeUI().textField().nombre().ValeurChampNombreObjetAvecPrecisionAfficheeSpecifiee(this, 'reglement', 'montantTTCReglement', true, 2)}
                                onFocus={() => Scriba.officeUI().textField().nombre().onFocusTextFieldNombreObjet(this, 'reglement', 'montantTTCReglement', this._onVerificationFormulaire)}
                                onBlur={e => this._onMiseAJourChampNombre("reglement", "montantTTCReglement", e.target.value, this._onVerificationFormulaire)}
                                onGetErrorMessage={e => Scriba.officeUI().textField().nombre().onGetErrorMessageTextFieldNombre(this, 'montantTTCReglement', e, true, 2)}
                                deferredValidationTime={0}
                                suffix="€"
                                required
                            />
                        </div>
                    </div>
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-lg6">
                            <EUIComboBox
                                idValeurParDefaut="0"
                                label="Mode"
                                onChange={(event, option) => this._onMiseAJourChamp("reglement", "mode", option.key)}
                                options={[
                                    { key: "Chèque", text: "Chèque" },
                                    { key: "Virement", text: "Virement" },
                                    { key: "Autre", text: "Autre" }
                                ]}
                                selectedKey={this.state.reglement.mode}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg6">
                            <EUITextField
                                label="Référence"
                                maxLength={MaxLengths.reglement.reference}
                                onDelayedChange={(event, newValue) => this._onMiseAJourChamp("reglement", "reference", newValue)}
                                value={this.state.reglement.reference}
                            />
                        </div>
                    </div>
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-lg6">
                            <EUITextField
                                label="Intitulé"
                                maxLength={MaxLengths.reglement.intitule}
                                onDelayedChange={(event, newValue) => this._onMiseAJourChamp("reglement", "intitule", newValue)}
                                required
                                value={this.state.reglement.intitule}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg6">
                            <EUITextField
                                label="Banque"
                                maxLength={MaxLengths.reglement.banque}
                                onDelayedChange={(event, newValue) => this._onMiseAJourChamp("reglement", "banque", newValue)}
                                value={this.state.reglement.banque}
                            />
                        </div>
                    </div>
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 boutonBlocSuiviCompteClient">
                            <PrimaryButton onClick={this._onEnregistrement} disabled={!this.state.onActiveBoutonEnregistrer} style={{ marginRight: '8px' }}>Enregistrer</PrimaryButton>
                            <DefaultButton onClick={() => this.setState({ reglement: {} }, this._onVerificationFormulaire)}>Annuler</DefaultButton>
                        </div>
                    </div>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-xl6">
                    <DetailsList
                        items={this.state.listReglements}
                        columns={this.columns}
                        selectionMode={SelectionMode.none}
                    />
                </div>
            </div>
        </div>;
    }

    constructor(props) {
        super(props);

        //#region chargement des columns
        let columnsTemp = [];
        columnsTemp.push({
            key: 'dateMouvement',
            name: 'Date',
            fieldName: 'dateMouvement',
            minWidth: 80,
            maxWidth: 80,
            isResizable: true,
            onRender: (item) => {
                return <span>{Scriba.date().stringDateFormatCourt(item.dateMouvement)}</span>;
            }
        });

        columnsTemp.push({
            key: 'intitule',
            name: 'Intitulé',
            fieldName: 'intitule',
            minWidth: 100,
            maxWidth: 200,
            isResizable: true,
            onRender: (item) => {
                if (item.typeReglement === 'Reservation_Echeancier_Stade') {
                    const libelle = `AF - ${item.nomStade}`;
                    return <span>{libelle}</span>;
                }
                else {
                    let libelle = "EC - " + item.intitule;
                    if (!!item.mode) libelle += ` - ${item.mode}`;
                    if (!!item.reference) libelle += ` - ${item.reference}`;

                    if (!this.props.peutModifierBlocSuiviCompteClient)
                        return <span>{libelle}</span>;
                    else
                        return <span className="labelStadeSuiviCompteClient" onClick={() => this.setState({ reglement: item }, this._onVerificationFormulaire)}>{libelle}</span>;
                }
            }
        });

        columnsTemp.push({
            key: 'montantTotalTTCFacture',
            name: 'Facturé',
            fieldName: 'montantTotalTTCFacture',
            minWidth: 100,
            maxWidth: 150,
            isResizable: true,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',

            onRender: (item) => {
                return (item.montantTotalTTCFacture !== null ? <span>{Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee((item.montantTotalTTCFacture).toFixed(2), false, 2)}&nbsp;€</span> : null);
            }
        });
        columnsTemp.push({
            key: 'montantTTCReglement',
            name: 'Encaissé',
            fieldName: 'montantTTCReglement',
            minWidth: 10,
            maxWidth: 150,
            isResizable: true,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',

            onRender: (item) => {
                return (item.montantTTCReglement !== null ? <span>{Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee((item.montantTTCReglement).toFixed(2), true, 2)}&nbsp;€</span> : null);
            }
        });

        if (this.props.peutSupprimerBlocSuiviCompteClient) {
            columnsTemp.push({
                key: 'suppression',
                name: '',
                ariaLabel: 'Suppression du compte client',
                fieldName: 'suppression',
                minWidth: 20,
                maxWidth: 20,
                iconName: '',
                isIconOnly: true,
                isSorted: false,
                onRender: (item) => {
                    if (item.typeReglement === 'Reservation_Echeancier_Stade')
                        return null;
                    else
                        return <IconButton
                            iconProps={{ iconName: 'Delete' }}
                            title="Supprimer"
                            ariaLabel="Suppression"
                            onClick={() => this._onSuppression(item.idReglement)}
                        />;

                }
            });
        }

        this.columns = columnsTemp;
        //#endregion

        this.state = objetState;
    }

    _onInit() {
        this.setState(objetState);
    }

    _chargementDonnees = () => {

        const { idOperation, idReservation } = this.props;

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Chargement du suivi de compte client'
        });

        DataSuiviCompteClient._chargementSuiviCompteClient(idOperation, idReservation)
            .then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    const listReglements = responseFetch.reponseAPIobjet || [];

                    // Calcul totaux
                    let totalFacture = 0;
                    let totalEncaisse = 0;

                    listReglements.forEach(reglement => {
                        totalFacture = totalFacture + (reglement.montantTotalTTCFacture !== null ? parseFloat(reglement.montantTotalTTCFacture) : 0);
                        totalEncaisse = totalEncaisse + (reglement.montantTTCReglement !== null ? parseFloat(reglement.montantTTCReglement) : 0);
                    });

                    const stateTemp = {
                        listReglements,
                        reglement: {},
                        totalAEncaisser: totalFacture - totalEncaisse,
                        totalEncaisse: totalEncaisse,
                        totalFacture: totalFacture,
                    };
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, stateTemp, this._onVerificationFormulaire);
                }
                else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
            });
    };

    _onEnregistrement = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Enregistrement de l\'encaissement'
        });

        var enregistrementReglement = DataReglement._onEnregistrementReglement(this.props.idOperation, this.props.idReservation, this.state.reglement);

        enregistrementReglement
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    this._chargementDonnees();
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    _onSuppression(idReglement) {
        if (window.confirm("Voulez-vous supprimer ce règlement ?")) {
            this.setState({
                enCoursDeTraitement: true,
                messageEnCoursTraitement: 'Suppression de l\'encaissement'
            });

            var suppressionReglement = DataReglement._onSuppressionReglement(idReglement);

            suppressionReglement
                .then(responseFetch => {
                    let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                    if (retourVerif === null) {
                        this._chargementDonnees();
                    }
                    else {
                        Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                    }
                });
        }
    }

    _onAnnulation = () => {
        this._onInit();
        this.props.onAnnuleFiche();
    }

    _onMiseAJourChamp(nomObjet, nomPropriete, valeur) {
        Scriba.state().setObjetPropriete(this, nomObjet, nomPropriete, valeur, this._onVerificationFormulaire);
    }

    _onMiseAJourChampNombre = (nomObjet, nomPropriete, valeur) => {
        Scriba.officeUI().textField().nombre().onBlurTextFieldNombreObjet(this, nomObjet, nomPropriete, valeur, 'fr', this._onVerificationFormulaire)
    }

    _onVerificationFormulaire() {
        Immocom.fiche()._validationFormulaire(this, 'Reglement', this.state.reglement, (this.state.reglement.idReglement > 0 ? 'Modification' : 'Création'));
    }

    componentDidMount = () => {
        const { idOperation, idReservation } = this.props;
        if (!!idOperation && !!idReservation)
            this._chargementDonnees();
    };

    componentDidUpdate = (prevProps) => {
        const { idOperation, idReservation } = this.props;
        if (!!idOperation && !!idReservation)
            if (idOperation !== prevProps.idOperation || idReservation !== prevProps.idReservation)
                this._chargementDonnees();
    };

    render = () => {
        return this._creationContent();
    };

}